(function () {
  "use strict";

  // Get data from DOM attributes
  const productPage = document.getElementById(
    "MainProduct-" +
      (document.querySelector("[data-section]")?.dataset.section || "")
  );
  if (!productPage) return;

  const productFormId =
    productPage.dataset.productFormId ||
    productPage.querySelector("form")?.id ||
    "";
  const sectionId = productPage.dataset.section || "";
  const productData = window.productData;
  const variantData = window.productVariantData;
  const productForm = document.getElementById(productFormId);

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    initGallery();
    initZoomPopup();
    initVariantSelection();
    initQuantitySelector();
    initFormSubmission();
    initDescriptionToggle();
    initLocationPopup();
    initAskShareModals();
    initStockWarning();
    initStickyBar();
    checkUrlVariant();
    initBuyItNow();
  }

  // Gallery initialization
  function initGallery() {
    const slider = document.querySelector(".product-gallery-slider");
    if (!slider) return;

    const customSlider = slider.closest("custom-slider");
    const thumbnails = document.querySelectorAll(".gallery-thumbnail");

    if (!customSlider) return;

    // Thumbnail click handler
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        const thumbIndex = parseInt(thumb.dataset.thumbnailIndex || index);
        if (customSlider && customSlider.goToSlide) {
          customSlider.goToSlide(thumbIndex);
          // Update thumbnails immediately on click
          updateThumbnails(thumbIndex);
        }
      });
    });

    // Update thumbnails when custom-slider changes slide
    let lastIndex = -1;
    const track = slider.querySelector("[data-slider-track]");

    // Function to get the currently visible slide's mediaIndex
    const getCurrentMediaIndex = () => {
      if (!track) return 0;

      const slides = track.querySelectorAll("[data-slider-item]");
      if (slides.length === 0) return 0;

      const trackRect = track.getBoundingClientRect();
      const sliderRect = slider.getBoundingClientRect();
      const centerX = sliderRect.left + sliderRect.width / 2;

      // Find the slide that's most centered
      for (let i = 0; i < slides.length; i++) {
        const slideRect = slides[i].getBoundingClientRect();
        // Check if slide is centered (within 50% of slider width from center)
        if (slideRect.left <= centerX && slideRect.right >= centerX) {
          return parseInt(slides[i].dataset.mediaIndex || i);
        }
      }

      // Fallback: find closest slide to center
      let closestIndex = 0;
      let closestDistance = Infinity;
      for (let i = 0; i < slides.length; i++) {
        const slideRect = slides[i].getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = parseInt(slides[i].dataset.mediaIndex || i);
        }
      }

      return closestIndex;
    };

    // Function to update thumbnails
    const updateFromSlider = () => {
      const currentMediaIndex = getCurrentMediaIndex();
      if (currentMediaIndex !== lastIndex) {
        lastIndex = currentMediaIndex;
        updateThumbnails(currentMediaIndex);
      }
    };

    // Watch for transform changes on the track
    if (track) {
      const trackObserver = new MutationObserver(() => {
        updateFromSlider();
      });
      trackObserver.observe(track, {
        attributes: true,
        attributeFilter: ["style"],
        subtree: false,
      });

      // Listen to transition events
      track.addEventListener("transitionend", updateFromSlider);
      track.addEventListener("transitionstart", updateFromSlider);

      // Listen for drag end
      let isDragging = false;
      track.addEventListener("mousedown", () => {
        isDragging = true;
      });
      track.addEventListener("touchstart", () => {
        isDragging = true;
      });
      track.addEventListener("mouseup", () => {
        if (isDragging) {
          setTimeout(updateFromSlider, 100);
          isDragging = false;
        }
      });
      track.addEventListener("touchend", () => {
        if (isDragging) {
          setTimeout(updateFromSlider, 100);
          isDragging = false;
        }
      });
    }

    // Also use custom-slider's currentIndex if available
    if (customSlider.currentIndex !== undefined) {
      const checkCustomSliderIndex = () => {
        if (customSlider.currentIndex !== undefined) {
          const track = slider.querySelector("[data-slider-track]");
          if (track) {
            const slides = track.querySelectorAll("[data-slider-item]");
            if (slides[customSlider.currentIndex]) {
              const mediaIndex = parseInt(
                slides[customSlider.currentIndex].dataset.mediaIndex ||
                  customSlider.currentIndex
              );
              if (mediaIndex !== lastIndex) {
                lastIndex = mediaIndex;
                updateThumbnails(mediaIndex);
              }
            }
          }
        }
      };

      // Check periodically for currentIndex changes
      const indexCheckInterval = setInterval(checkCustomSliderIndex, 150);

      // Cleanup on unload
      window.addEventListener("beforeunload", () => {
        clearInterval(indexCheckInterval);
      });
    }

    // Initial update
    setTimeout(updateFromSlider, 200);
  }

  function updateThumbnails(activeIndex) {
    document.querySelectorAll(".gallery-thumbnail").forEach((thumb, index) => {
      const thumbIndex = parseInt(thumb.dataset.thumbnailIndex || index);
      thumb.classList.toggle("active", thumbIndex === activeIndex);
    });
  }

  // Zoom Popup functionality
  function initZoomPopup() {
    const zoomBtns = document.querySelectorAll(".gallery-zoom-btn");
    const zoomPopup = document.getElementById("product-zoom-popup");
    const zoomClose = document.querySelector(".zoom-popup-close");
    const zoomSlides = document.querySelectorAll(".zoom-popup-slide");
    const zoomThumbnails = document.querySelectorAll(".zoom-thumbnail");
    const zoomImages = document.querySelectorAll(".zoom-popup-image");

    if (zoomBtns.length === 0 || !zoomPopup) {
      console.warn("Zoom popup elements not found");
      return;
    }

    // Ensure popup is at body level for proper z-index stacking
    if (zoomPopup.parentNode !== document.body) {
      document.body.appendChild(zoomPopup);
    }

    let currentZoomIndex = 0;
    let isZoomed = false;
    let zoomScale = 1;
    let panX = 0;
    let panY = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartPanX = 0;
    let dragStartPanY = 0;
    let isAnimating = false; // Flag to prevent interactions during animation
    let animatedImageElement = null; // Track the animated image

    // Open zoom popup with animation (like hero.liquid)
    // Attach event listener to all zoom buttons (desktop and mobile)
    zoomBtns.forEach((zoomBtn) => {
      zoomBtn.addEventListener("click", async () => {
        if (isAnimating) return; // Prevent during animation

        // Reset popup state before opening
        if (zoomPopup) {
          zoomPopup.style.display = "block";
          if (typeof gsap !== "undefined") {
            gsap.set(zoomPopup, { y: 0, opacity: 0, visibility: "visible" });
          }
        }

        // Get the currently active slide from custom-slider
        const slider = document.querySelector(".product-gallery-slider");
        const customSlider = slider ? slider.closest("custom-slider") : null;
        let activeSlide = null;
        let activeIndex = 0;

        if (customSlider && customSlider.currentIndex !== undefined) {
          // Use custom-slider's currentIndex
          activeIndex = customSlider.currentIndex;
          const slides = slider.querySelectorAll(
            ".product-gallery-slide[data-slider-item]"
          );
          if (slides[activeIndex]) {
            activeSlide = slides[activeIndex];
            activeIndex = parseInt(
              activeSlide.dataset.mediaIndex || activeIndex
            );
          }
        }

        // Fallback: find by position
        if (!activeSlide) {
          const track = slider
            ? slider.querySelector("[data-slider-track]")
            : null;
          if (track) {
            const slides = track.querySelectorAll(
              ".product-gallery-slide[data-slider-item]"
            );
            const trackRect = track.getBoundingClientRect();
            const trackCenter = trackRect.left + trackRect.width / 2;

            slides.forEach((slide, index) => {
              const slideRect = slide.getBoundingClientRect();
              if (
                slideRect.left <= trackCenter &&
                slideRect.right >= trackCenter
              ) {
                activeSlide = slide;
                activeIndex = parseInt(slide.dataset.mediaIndex || index);
              }
            });
          }
        }

        // Final fallback
        if (!activeSlide) {
          activeSlide = document.querySelector(
            ".product-gallery-slide[data-slider-item]"
          );
          activeIndex = parseInt(activeSlide?.dataset.mediaIndex || "0");
        }

        if (!activeSlide) return;

        currentZoomIndex = activeIndex;
        const activeImage = activeSlide.querySelector(".product-gallery-image");
        const popupSlide = zoomSlides[currentZoomIndex];
        const popupImage = popupSlide
          ? popupSlide.querySelector(".zoom-popup-image")
          : null;

        if (!activeImage || !popupImage) {
          zoomPopup.classList.add("active");
          document.body.style.overflow = "hidden";
          updateZoomPopup();
          return;
        }

        // Keep popup image hidden initially (will be shown after clone animation)
        popupImage.style.setProperty("opacity", "0", "important");
        popupImage.style.setProperty("pointer-events", "none", "important");

        // Animate clone from slider to popup
        await animateImageToPopup(activeImage, popupSlide, popupImage);
      });
    });

    async function animateImageToPopup(sourceImage, popupSlide, popupImage) {
      isAnimating = true; // Prevent interactions during animation

      if (typeof gsap === "undefined") {
        // Fallback without GSAP
        zoomPopup.style.display = "block";
        zoomPopup.classList.add("active");
        document.body.style.overflow = "hidden";
        updateZoomPopup();
        isAnimating = false;
        return;
      }

      // Get source position (gallery image)
      const sourceRect = sourceImage.getBoundingClientRect();

      // Clone the source image for animation
      const clone = sourceImage.cloneNode(true);
      clone.style.position = "fixed";
      clone.style.top = sourceRect.top + "px";
      clone.style.left = sourceRect.left + "px";
      clone.style.width = sourceRect.width + "px";
      clone.style.height = sourceRect.height + "px";
      clone.style.margin = "0";
      clone.style.zIndex = "10008";
      clone.style.pointerEvents = "none";
      clone.style.objectFit = "contain";
      clone.style.willChange = "top, left, width, height";
      clone.classList.add("zoom-animation-clone");
      document.body.appendChild(clone);
      animatedImageElement = clone; // Track cloned image

      // Show popup but keep it invisible for measurement
      zoomPopup.style.display = "block";
      gsap.set(zoomPopup, {
        y: 0,
        opacity: 0,
        pointerEvents: "none",
        visibility: "hidden",
      });
      zoomPopup.classList.add("active");

      // Wait for layout
      await new Promise((resolve) => requestAnimationFrame(resolve));
      await new Promise((resolve) => requestAnimationFrame(resolve));

      // Wait for popup image to load
      if (!popupImage.complete) {
        await new Promise((resolve) => {
          popupImage.addEventListener("load", resolve, { once: true });
          popupImage.addEventListener("error", resolve, { once: true });
        });
        await new Promise((resolve) => requestAnimationFrame(resolve));
      }

      // Get target position (where popup image is)
      const targetRect = popupImage.getBoundingClientRect();

      // Reset popup for animation
      gsap.set(zoomPopup, {
        y: "15vh",
        opacity: 0,
        pointerEvents: "none",
        visibility: "visible",
      });

      // Animate both clone and popup (faster, ease-out)
      const tl = gsap.timeline({
        defaults: { ease: "power2.out" },
      });

      // Animate clone to target position (faster: 0.6s)
      tl.to(
        clone,
        {
          top: targetRect.top,
          left: targetRect.left,
          width: targetRect.width,
          height: targetRect.height,
          duration: 0.6,
          ease: "power2.out",
          onComplete: () => {
            // Remove clone after animation
            if (clone.parentNode) {
              clone.remove();
            }
            // Show the actual popup image
            popupImage.classList.remove("zoom-popup-image-placeholder");
            popupImage.style.setProperty("opacity", "1", "important");
            popupImage.style.setProperty("pointer-events", "auto", "important");
            popupImage.style.setProperty("display", "block", "important");
            zoomPopup.style.pointerEvents = "auto";
            isAnimating = false; // Allow interactions after animation
            animatedImageElement = null;
          },
        },
        0
      );

      // Animate popup in simultaneously with image movement (same duration: 0.6s)
      tl.to(
        zoomPopup,
        { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" },
        0
      );

      document.body.style.overflow = "hidden";
      updateZoomPopup();
    }

    // Close zoom popup with animation (reverse of open)
    async function closeZoomPopup() {
      if (isAnimating) return; // Prevent during animation

      isAnimating = true;

      if (typeof gsap === "undefined") {
        // Fallback without GSAP
        zoomPopup.classList.remove("active");
        document.body.style.overflow = "";
        resetZoom();
        isAnimating = false;
        return;
      }

      const popupSlide = zoomSlides[currentZoomIndex];
      // Get the actual popup image (not placeholder)
      const popupImage = popupSlide
        ? popupSlide.querySelector(
            ".zoom-popup-image:not(.zoom-popup-image-placeholder)"
          )
        : null;

      // Find the target slide by matching mediaIndex or data-gallery-id
      const slides = document.querySelectorAll(
        ".product-gallery-slide[data-slider-item]"
      );
      let targetSlide = null;
      let targetImage = null;

      if (popupImage && popupImage.dataset.galleryId) {
        // Find by matching data-gallery-id
        targetImage = document.querySelector(
          `[data-image-id="${popupImage.dataset.galleryId}"]`
        );
        if (targetImage) {
          targetSlide = targetImage.closest(".product-gallery-slide");
        }
      }

      // Fallback: find by mediaIndex
      if (!targetSlide) {
        slides.forEach((slide) => {
          const mediaIndex = parseInt(slide.dataset.mediaIndex || "-1");
          if (mediaIndex === currentZoomIndex) {
            targetSlide = slide;
            targetImage = slide.querySelector(".product-gallery-image");
          }
        });
      }

      if (!popupImage || !targetSlide || !targetImage) {
        if (zoomPopup) {
          zoomPopup.classList.remove("active");
          zoomPopup.style.display = "none";
        }
        document.body.style.overflow = "";
        resetZoom();
        isAnimating = false;
        return;
      }

      // Get target position in slider (use image position)
      const targetRect = targetImage.getBoundingClientRect();
      const popupRect = popupImage.getBoundingClientRect();

      // Clone the popup image for animation
      const clone = popupImage.cloneNode(true);
      clone.style.position = "fixed";
      clone.style.top = popupRect.top + "px";
      clone.style.left = popupRect.left + "px";
      clone.style.width = popupRect.width + "px";
      clone.style.height = popupRect.height + "px";
      clone.style.margin = "0";
      clone.style.zIndex = "10008";
      clone.style.pointerEvents = "none";
      clone.style.willChange = "top, left, width, height";
      clone.classList.add("zoom-animation-clone");
      document.body.appendChild(clone);
      animatedImageElement = clone; // Track cloned image

      // Hide popup image during animation
      popupImage.style.setProperty("opacity", "0", "important");
      popupImage.style.setProperty("pointer-events", "none", "important");

      // Reset zoom state
      resetZoom();

      // Animate clone back to slider (faster, ease-out)
      const tl = gsap.timeline({
        defaults: { ease: "power2.out" },
        onComplete: () => {
          // Remove clone after animation
          if (clone.parentNode) {
            clone.remove();
          }
          // Cleanup after all animations complete
          if (zoomPopup) {
            zoomPopup.classList.remove("active");
            zoomPopup.style.display = "none";
            gsap.set(zoomPopup, { clearProps: "all" });
          }
          document.body.style.overflow = "";
          isAnimating = false;
          animatedImageElement = null;
        },
      });

      // Animate popup out simultaneously with clone movement (same duration: 0.6s)
      tl.to(
        zoomPopup,
        {
          y: "15vh",
          opacity: 0,
          duration: 0.6,
          ease: "power2.out",
        },
        0
      );

      // Animate clone back to slider
      tl.to(
        clone,
        {
          top: targetRect.top,
          left: targetRect.left,
          width: targetRect.width,
          height: targetRect.height,
          duration: 0.6,
          ease: "power2.out",
        },
        0
      );
    }

    if (zoomClose) {
      zoomClose.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        closeZoomPopup();
      });
    }

    if (zoomPopup) {
      zoomPopup.addEventListener("click", (e) => {
        // Close if clicking on popup background (not on image or thumbnails)
        if (e.target === zoomPopup) {
          e.preventDefault();
          closeZoomPopup();
        } else if (
          e.target.closest(".zoom-popup-slider") === null &&
          e.target.closest(".zoom-popup-thumbnails") === null &&
          e.target.closest(".zoom-popup-close") === null &&
          e.target.closest(".zoom-popup-content") === null
        ) {
          e.preventDefault();
          closeZoomPopup();
        }
      });
    }

    // Thumbnail navigation in zoom popup
    zoomThumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", (e) => {
        e.stopPropagation();
        if (isAnimating) return;
        currentZoomIndex = index;
        updateZoomPopup();
        resetZoom();
      });
    });

    // Keyboard navigation
    document.addEventListener("keydown", (e) => {
      if (!zoomPopup || !zoomPopup.classList.contains("active")) return;

      if (e.key === "Escape") {
        e.preventDefault();
        closeZoomPopup();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        currentZoomIndex = (currentZoomIndex + 1) % zoomSlides.length;
        updateZoomPopup();
        resetZoom();
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        currentZoomIndex =
          (currentZoomIndex - 1 + zoomSlides.length) % zoomSlides.length;
        updateZoomPopup();
        resetZoom();
      }
    });

    function updateZoomPopup() {
      zoomSlides.forEach((slide, index) => {
        const isActive = index === currentZoomIndex;
        slide.classList.toggle("active", isActive);

        // Get all images in the slide
        const allImages = slide.querySelectorAll(".zoom-popup-image");

        allImages.forEach((img) => {
          if (isActive) {
            // For active slide, remove placeholder class and make visible
            img.classList.remove("zoom-popup-image-placeholder");
            // Use setProperty with important flag to override CSS !important
            img.style.setProperty("opacity", "1", "important");
            img.style.setProperty("pointer-events", "auto", "important");
            img.style.setProperty("display", "block", "important");
          } else {
            // For inactive slides, hide images
            img.style.setProperty("opacity", "0", "important");
            img.style.setProperty("pointer-events", "none", "important");
          }
        });
      });
      zoomThumbnails.forEach((thumb, index) => {
        thumb.classList.toggle("active", index === currentZoomIndex);
      });
      // Update current zoom image reference
      currentZoomImage = getCurrentZoomImage();
    }

    // Zoom functionality with click threshold
    let clickStartX = 0;
    let clickStartY = 0;
    let clickThreshold = 8; // 8px threshold
    let mouseDownOnImage = false;
    let hasMoved = false;
    let currentZoomImage = null; // Track current active zoom image

    // Function to get current active zoom image
    const getCurrentZoomImage = () => {
      const activeSlide = zoomSlides[currentZoomIndex];
      if (activeSlide) {
        return activeSlide.querySelector(
          ".zoom-popup-image:not(.zoom-popup-image-placeholder)"
        );
      }
      return null;
    };

    // Use event delegation on zoom popup slider
    const zoomSlider = document.querySelector(".zoom-popup-slider");
    if (zoomSlider) {
      zoomSlider.addEventListener("mousedown", function (e) {
        const img = e.target.closest(".zoom-popup-image");
        if (
          !img ||
          img.classList.contains("zoom-popup-image-placeholder") ||
          isAnimating
        )
          return;

        clickStartX = e.clientX;
        clickStartY = e.clientY;
        mouseDownOnImage = true;
        hasMoved = false;
        isDragging = false;
        currentZoomImage = img;

        if (isZoomed) {
          // Pan when zoomed
          dragStartX = e.clientX;
          dragStartY = e.clientY;
          dragStartPanX = panX;
          dragStartPanY = panY;
          e.preventDefault();
        }
      });

      // Also handle touch events
      zoomSlider.addEventListener("touchstart", function (e) {
        const img = e.target.closest(".zoom-popup-image");
        if (
          !img ||
          img.classList.contains("zoom-popup-image-placeholder") ||
          isAnimating
        )
          return;

        const touch = e.touches[0];
        clickStartX = touch.clientX;
        clickStartY = touch.clientY;
        mouseDownOnImage = true;
        hasMoved = false;
        isDragging = false;
        currentZoomImage = img;

        if (isZoomed) {
          // Pan when zoomed
          dragStartX = touch.clientX;
          dragStartY = touch.clientY;
          dragStartPanX = panX;
          dragStartPanY = panY;
          e.preventDefault();
        }
      });

      const handleMouseMove = function (e) {
        if (!mouseDownOnImage || isAnimating) return;

        const currentX = e.type.includes("touch")
          ? e.touches[0].clientX
          : e.clientX;
        const currentY = e.type.includes("touch")
          ? e.touches[0].clientY
          : e.clientY;

        if (isZoomed && currentZoomImage) {
          // Check if moved beyond threshold
          const deltaX = Math.abs(currentX - clickStartX);
          const deltaY = Math.abs(currentY - clickStartY);

          if (
            !hasMoved &&
            (deltaX > clickThreshold || deltaY > clickThreshold)
          ) {
            hasMoved = true;
            isDragging = true;
          }

          if (isDragging && hasMoved) {
            const deltaX = currentX - dragStartX;
            const deltaY = currentY - dragStartY;

            const rect = currentZoomImage.getBoundingClientRect();
            const maxPanX = (rect.width * zoomScale - rect.width) / 2;
            const maxPanY = (rect.height * zoomScale - rect.height) / 2;

            panX = Math.max(
              -maxPanX,
              Math.min(maxPanX, dragStartPanX + deltaX)
            );
            panY = Math.max(
              -maxPanY,
              Math.min(maxPanY, dragStartPanY + deltaY)
            );

            currentZoomImage.style.transform = `scale(${zoomScale}) translate(${
              panX / zoomScale
            }px, ${panY / zoomScale}px)`;
            e.preventDefault();
          }
        }
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("touchmove", handleMouseMove, {
        passive: false,
      });

      zoomSlider.addEventListener("click", function (e) {
        const img = e.target.closest(".zoom-popup-image");
        if (
          !img ||
          img.classList.contains("zoom-popup-image-placeholder") ||
          isAnimating
        )
          return;

        // Check if movement exceeded threshold (drag vs click)
        const deltaX = Math.abs(e.clientX - clickStartX);
        const deltaY = Math.abs(e.clientY - clickStartY);
        const totalMovement = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

        // If moved more than threshold, it was a drag - don't zoom
        if (totalMovement > clickThreshold) {
          mouseDownOnImage = false;
          hasMoved = false;
          return;
        }

        // It was a click - handle zoom
        e.preventDefault();
        e.stopPropagation();

        if (isZoomed) {
          resetZoom();
        } else {
          const rect = img.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const clickY = e.clientY - rect.top;
          zoomImage(img, clickX, clickY);
        }

        mouseDownOnImage = false;
        hasMoved = false;
      });

      const handleMouseUp = (e) => {
        // On drag end, check if movement exceeded threshold
        if (mouseDownOnImage && isZoomed && currentZoomImage) {
          const endX =
            e.type && e.type.includes("touch")
              ? e.changedTouches[0].clientX
              : e.clientX;
          const endY =
            e.type && e.type.includes("touch")
              ? e.changedTouches[0].clientY
              : e.clientY;

          const deltaX = Math.abs(endX - clickStartX);
          const deltaY = Math.abs(endY - clickStartY);
          const totalMovement = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

          // If moved more than threshold, prevent click event from firing
          if (totalMovement > clickThreshold) {
            // Prevent the click event
            if (zoomSlider) {
              const clickHandler = (clickE) => {
                clickE.preventDefault();
                clickE.stopPropagation();
                zoomSlider.removeEventListener("click", clickHandler);
              };
              zoomSlider.addEventListener("click", clickHandler, {
                once: true,
              });
            }
          }
        }

        mouseDownOnImage = false;
        hasMoved = false;
        isDragging = false;
      };

      document.addEventListener("mouseup", handleMouseUp);
      document.addEventListener("mouseleave", handleMouseUp);
      document.addEventListener("touchend", handleMouseUp, { passive: false });
    }

    function zoomImage(img, clickX, clickY) {
      zoomScale = 2;
      const rect = img.getBoundingClientRect();
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      // Calculate pan to center on click point
      panX = (centerX - clickX) * (zoomScale - 1);
      panY = (centerY - clickY) * (zoomScale - 1);

      // Clamp pan values
      const maxPanX = (rect.width * zoomScale - rect.width) / 2;
      const maxPanY = (rect.height * zoomScale - rect.height) / 2;
      panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
      panY = Math.max(-maxPanY, Math.min(maxPanY, panY));

      img.style.transition = "transform 0.3s ease-out";
      img.style.transform = `scale(${zoomScale}) translate(${
        panX / zoomScale
      }px, ${panY / zoomScale}px)`;
      img.style.cursor = "zoom-out";
      isZoomed = true;
    }

    function resetZoom() {
      const activeImg = getCurrentZoomImage();
      if (activeImg) {
        activeImg.style.transition = "transform 0.3s ease-out";
        activeImg.style.transform = "";
        activeImg.style.cursor = "zoom-in";
      }
      isZoomed = false;
      zoomScale = 1;
      panX = 0;
      panY = 0;
    }
  }

  // Variant Selection
  function initVariantSelection() {
    if (!productPage || !variantData) {
      return;
    }

    const variantRadios = productPage.querySelectorAll(
      '.variant-selector input[type="radio"]'
    );
    const variantLabels = productPage.querySelectorAll(
      ".variant-selector .option-value"
    );

    // Listen for change events on radio inputs
    variantRadios.forEach((radio) => {
      // Skip if already has listener (check for data-variant-selector which are for quotation form)
      if (!radio.hasAttribute("data-listener-attached")) {
        radio.addEventListener("change", function (e) {
          handleVariantChange(e);
        });
        radio.setAttribute("data-listener-attached", "true");
      }
    });

    // Also listen for clicks on labels to ensure change fires
    variantLabels.forEach((label) => {
      label.addEventListener("click", function (e) {
        const inputId = this.getAttribute("for");
        const input = document.getElementById(inputId);

        if (input) {
          // Check if input is disabled
          if (input.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }

          // If clicking on a different option in the same group, uncheck others first
          const optionGroup = input.closest(".variant-option");
          if (optionGroup) {
            optionGroup
              .querySelectorAll('input[type="radio"]')
              .forEach((radio) => {
                if (radio.id !== inputId) {
                  radio.checked = false;
                }
              });
          }

          // Check the clicked input
          input.checked = true;

          // Trigger change event
          const changeEvent = new Event("change", { bubbles: true });
          input.dispatchEvent(changeEvent);
        }
      });
    });

    // Handle color swatches
    const colorSwatches = productPage.querySelectorAll(".color-swatch");
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", function (e) {
        e.preventDefault();
        const optionValue = this.dataset.value;
        const optionName = this.dataset.option;
        const radio = productPage.querySelector(
          `input[type="radio"][name="${optionName}"][value="${optionValue}"]`
        );
        if (radio && !radio.disabled && !radio.classList.contains("disabled")) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });

    function handleVariantChange(e) {
      // Update selected state on labels
      document.querySelectorAll(".option-value").forEach((label) => {
        label.classList.remove("selected");
      });

      // Update selected value display in legend
      document
        .querySelectorAll(".variant-option")
        .forEach((fieldset, optionIndex) => {
          const checkedRadio = fieldset.querySelector(
            'input[type="radio"]:checked'
          );
          if (checkedRadio) {
            const label = document.querySelector(
              `label[for="${checkedRadio.id}"]`
            );
            if (label) {
              label.classList.add("selected");
            }

            // Update the selected-value span in the legend
            const selectedValueSpan = fieldset.querySelector(
              "[data-selected-value]"
            );
            if (selectedValueSpan) {
              selectedValueSpan.textContent = checkedRadio.value;
            }
          }
        });

      const selectedOptions = getSelectedOptions();
      const selectedVariant = findVariantByOptions(selectedOptions);

      if (selectedVariant) {
        updateVariant(selectedVariant);
      }

      // Update option availability based on current selections
      updateOptionAvailability(selectedOptions);

      // Update quotation form product field if it exists
      updateQuotationProductField();
    }

    function updateQuotationProductField() {
      const productField = document.getElementById(
        "quotation-product-field-" + sectionId
      );
      if (!productField || !productData) return;

      const selectedOptions = [];
      const variantSelector = document.getElementById(
        "variant-selects-" + sectionId
      );
      if (variantSelector) {
        // Get checked variants in the correct order by iterating through variant option groups
        const variantOptions =
          variantSelector.querySelectorAll(".variant-option");

        variantOptions.forEach((optionGroup) => {
          const checkedRadio = optionGroup.querySelector(
            'input[type="radio"]:checked'
          );
          if (checkedRadio) {
            selectedOptions.push(checkedRadio.value);
          }
        });
      }

      const variantText =
        selectedOptions.length > 0 ? " - " + selectedOptions.join(" / ") : "";
      productField.value = productData.title + variantText;
    }

    function getSelectedOptions() {
      const selectedOptions = [];
      document.querySelectorAll(".variant-option").forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          selectedOptions.push(checked.value);
        } else {
          selectedOptions.push(null);
        }
      });
      return selectedOptions;
    }

    function findVariantByOptions(options) {
      return variantData.variants.find((variant) => {
        return variant.options.every(
          (opt, idx) => !options[idx] || options[idx] === opt
        );
      });
    }

    function updateOptionAvailability(selectedOptions) {
      if (!variantData || !variantData.options) return;

      variantData.options.forEach((optionName, optionIndex) => {
        const groupInputs = document.querySelectorAll(
          `.variant-option:nth-child(${optionIndex + 1}) input`
        );
        groupInputs.forEach((input) => {
          // Check if this option value can form a valid variant with current selections
          const isPossible = variantData.variants.some((variant) => {
            if (!variant.available) return false;
            return variant.options.every((opt, idx) => {
              // For the current option index, check if it matches the input value
              if (idx === optionIndex) return opt === input.value;
              // For other options, check if they match selected values (or if nothing selected yet)
              return !selectedOptions[idx] || selectedOptions[idx] === opt;
            });
          });

          if (isPossible) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      });
    }

    // Initialize option availability on page load
    setTimeout(() => {
      if (variantData && variantData.options) {
        const initialOptions = getSelectedOptions();
        updateOptionAvailability(initialOptions);

        // Update quotation form product field after initial variant setup
        updateQuotationProductField();
      }
    }, 100);

    function updateVariant(variant) {
      // Update hidden select
      const variantSelect = productForm.querySelector('select[name="id"]');
      if (variantSelect) {
        variantSelect.value = variant.id;
        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // Update URL
      if (productData && productData.url) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      }

      // Update prices
      updatePrices(variant);

      // Update availability
      updateAvailability(variant);

      // Update gallery
      updateGalleryImage(variant);

      // Update stock warning
      updateStockWarning(variant);

      // Update sticky bar
      if (window.updateStickyBarVariant) {
        window.updateStickyBarVariant(variant);
      }
    }

    function updatePrices(variant) {
      const currentPrice = document.querySelector(".product-current-price");
      const comparePrice = document.querySelector(".product-compare-price");
      const savings = document.querySelector(".product-savings .save-discount");

      if (currentPrice) {
        currentPrice.textContent = Shopify.formatMoney(
          variant.price,
          window.money_without_trailing_zeros_format
        );
      }

      if (comparePrice && savings) {
        if (variant.compare_at_price > variant.price) {
          comparePrice.textContent = Shopify.formatMoney(
            variant.compare_at_price,
            window.money_without_trailing_zeros_format
          );
          comparePrice.style.display = "inline-flex";
          const saveValue =
            100 - (variant.price / variant.compare_at_price) * 100;
          savings.textContent = `${window.saveText} ${Math.ceil(saveValue)}%`;
          savings.closest(".product-savings").style.display = "inline-flex";
          if (currentPrice) currentPrice.classList.add("red");
        } else {
          comparePrice.style.display = "none";
          savings.closest(".product-savings").style.display = "none";
          if (currentPrice) currentPrice.classList.remove("red");
        }
      }
    }

    function updateAvailability(variant) {
      const addToCartBtn = productForm.querySelector(".add-to-cart-btn");
      if (addToCartBtn) {
        if (variant.available) {
          // Preserve the icon when updating text
          const iconSpan = addToCartBtn.querySelector("span");
          const iconHTML = iconSpan ? iconSpan.outerHTML : "";
          addToCartBtn.innerHTML = "Add to Cart " + iconHTML;
          addToCartBtn.disabled = false;
        } else {
          addToCartBtn.textContent = "Sold Out";
          addToCartBtn.disabled = true;
        }
      }
    }

    function updateGalleryImage(variant) {
      if (!variant.featured_media || !variant.featured_media.id) return;

      const slider = document.querySelector(".product-gallery-slider");
      const customSlider = slider ? slider.closest("custom-slider") : null;

      if (!slider || !customSlider || !customSlider.goToSlide) return;

      // Find the slide with matching media ID
      const slides = slider.querySelectorAll(
        ".product-gallery-slide[data-slider-item]"
      );

      let targetSlideIndex = -1;
      let mediaIndex = -1;

      slides.forEach((slide, index) => {
        const mediaId = parseInt(slide.dataset.mediaId);
        if (mediaId === variant.featured_media.id) {
          targetSlideIndex = index;
          // Get the media index from the slide's image for thumbnail update
          const slideImage = slide.querySelector(".product-gallery-image");
          if (slideImage && slideImage.dataset.mediaIndex) {
            mediaIndex = parseInt(slideImage.dataset.mediaIndex);
          } else {
            mediaIndex = index;
          }
        }
      });

      // If found, navigate to that slide
      if (targetSlideIndex >= 0) {
        customSlider.goToSlide(targetSlideIndex);
        // Update thumbnails to reflect the change using media index
        if (mediaIndex >= 0 && typeof updateThumbnails === "function") {
          updateThumbnails(mediaIndex);
        }
      }
    }
  }
  function initBuyItNow() {
    const buyNowBtn = document.getElementById("buy-it-now");
    if (!buyNowBtn || !productForm) return;

    buyNowBtn.addEventListener("click", async () => {
      const variantInput = productForm.querySelector(
        'select[name="id"], input[name="id"]'
      );
      const quantityInput = productPage.querySelector('input[name="quantity"]');
      if (!variantInput) return;

      const variantId = variantInput.value;
      const quantity = quantityInput
        ? Math.max(1, parseInt(quantityInput.value || 1))
        : 1;

      // Validate availability
      const variant = variantData?.variants?.find(
        (v) => v.id === parseInt(variantId)
      );

      if (!variant || !variant.available) {
        const stockError = productPage.querySelector(".stock-error");
        if (stockError) {
          stockError.textContent = "Variant unavailable.";
          stockError.style.display = "block";
        }
        return;
      }

      buyNowBtn.disabled = true;
      buyNowBtn.textContent = "Processing…";

      try {
        // Add to cart WITHOUT clearing existing items
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: variantId, quantity }],
          }),
        });

        // Go to checkout with full cart
        window.location.href = "/checkout";
      } catch (err) {
        const stockError = productPage.querySelector(".stock-error");
        if (stockError) {
          stockError.textContent = "Failed to proceed to checkout.";
          stockError.style.display = "block";
        }
      } finally {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = "Buy it now";
      }
    });
  }

  // Quantity Selector
  function initQuantitySelector() {
    const quantityInput = document.querySelector(".quantity-input");
    const quantityMinus = document.querySelector(".quantity-btn.minus");
    const quantityPlus = document.querySelector(".quantity-btn.plus");

    if (!quantityInput) return;

    const min = parseInt(
      quantityInput.dataset.min || quantityInput.getAttribute("min") || "1"
    );
    const max = parseInt(
      quantityInput.dataset.max || quantityInput.getAttribute("max") || "999"
    );

    if (quantityMinus) {
      quantityMinus.addEventListener("click", () => {
        const currentValue = parseInt(quantityInput.value || min);
        const newValue = Math.max(min, currentValue - 1);
        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener("click", () => {
        const currentValue = parseInt(quantityInput.value || min);
        const newValue = Math.min(max, currentValue + 1);
        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    quantityInput.addEventListener("change", function () {
      const value = parseInt(this.value || min);
      if (isNaN(value) || value < min) {
        this.value = min;
      } else if (value > max) {
        this.value = max;
      }
    });
  }

  // Form Submission
  function initFormSubmission() {
    if (!productForm) return;

    productForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);
      const submitBtn = productForm.querySelector('[type="submit"]');
      // Store original HTML to preserve icon
      const originalHTML = submitBtn ? submitBtn.innerHTML : "";
      const iconSpan = submitBtn ? submitBtn.querySelector("span") : null;
      const iconHTML = iconSpan ? iconSpan.outerHTML : "";

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = "Adding..." + iconHTML;
      }

      try {
        // Get selected upsell products
        const upsellProducts = [];
        document
          .querySelectorAll('input[name="upsell-products[]"]:checked')
          .forEach((checkbox) => {
            upsellProducts.push({
              id: checkbox.value,
              quantity: 1,
            });
          });

        // Create items array with main product and upsell products
        const items = [
          { id: formData.get("id"), quantity: formData.get("quantity") || 1 },
          ...upsellProducts,
        ];

        const cartUrl =
          (window.routes && window.routes.cart_add_url
            ? window.routes.cart_add_url
            : "/cart/add") + ".js";
        const response = await fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });

        const data = await response.json();

        // Check for error messages even if response is ok (Shopify can return 200 with errors)
        // Shopify cart API can return status 200 but with error messages in the response
        const errorMessage =
          data.description ||
          data.message ||
          data.error ||
          (data.status === 422 ? data.description : null);

        if (response.ok && !errorMessage) {
          // Fetch updated cart to get accurate quantities
          try {
            const cartResponse = await fetch("/cart.js");
            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              const variantId = parseInt(formData.get("id"));

              // Find the item in cart and update quantity input
              const cartItem = cartData.items.find(
                (item) => item.variant_id === variantId
              );
              const quantityInput =
                productPage.querySelector(".quantity-input");
              if (quantityInput && cartItem) {
                quantityInput.setAttribute(
                  "data-cart-quantity",
                  cartItem.quantity
                );
              }
            }
          } catch (err) {
            // Fallback: update quantity locally
            const quantityInput = productPage.querySelector(".quantity-input");
            if (quantityInput) {
              const currentCartQty =
                parseInt(quantityInput.getAttribute("data-cart-quantity")) || 0;
              const addedQty = parseInt(formData.get("quantity")) || 1;
              quantityInput.setAttribute(
                "data-cart-quantity",
                currentCartQty + addedQty
              );
            }
          }

          // Clear any previous error messages
          const stockError = productPage.querySelector(".stock-error");
          if (stockError) {
            stockError.textContent = "";
            stockError.style.display = "none";
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            variant: data,
            formData: Object.fromEntries(formData),
            product: productData,
          });

          // Update stock warning after cart update
          const variantSelect = productForm?.querySelector('select[name="id"]');
          if (variantSelect && variantData) {
            const currentVariantId = parseInt(variantSelect.value);
            const currentVariant = variantData.variants.find(
              (v) => v.id === currentVariantId
            );
            if (currentVariant) {
              updateStockWarning(currentVariant);
            }
          }
        } else {
          // Show error message in stock-error element
          const stockError = productPage.querySelector(".stock-error");
          const finalErrorMessage =
            errorMessage || data.description || "Failed to add to cart";

          if (stockError) {
            stockError.textContent = finalErrorMessage;
            stockError.style.setProperty("display", "block", "important");
            stockError.style.setProperty("color", "red", "important");
          }

          // Don't throw if response was ok but had a warning message (partial success)
          if (!response.ok) {
            throw new Error(finalErrorMessage);
          }
        }
      } catch (error) {
        // Display error in stock-error element
        const stockError = productPage.querySelector(".stock-error");
        if (stockError) {
          stockError.textContent = error.message;
          stockError.style.setProperty("display", "block", "important");
          stockError.style.setProperty("color", "red", "important");
        }

        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "add-to-cart",
          productId: productData.id,
        });
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
      }
    });
  }

  // Description Toggle
  function initDescriptionToggle() {
    const toggleMore = document.getElementById(
      "product-description-toggle-more"
    );
    const toggleLess = document.getElementById(
      "product-description-toggle-less"
    );
    const truncated = document.getElementById("product-description-truncated");
    const full = document.getElementById("product-description-full");

    if (!toggleMore || !toggleLess || !truncated || !full) return;

    function showFull() {
      truncated.classList.add("description-hidden");
      full.classList.remove("description-hidden");
    }

    function showTruncated() {
      full.classList.add("description-hidden");
      truncated.classList.remove("description-hidden");
    }

    // Make truncated description clickable to show full
    truncated.addEventListener("click", function () {
      showFull();
    });

    // Make full description clickable to show truncated
    full.addEventListener("click", function () {
      showTruncated();
    });
  }

  // Share button
  function initLocationPopup() {
    const triggers = document.querySelectorAll(".product-location-trigger");
    triggers.forEach((trigger) => {
      const popupId = trigger.dataset.locationPopupId;
      const popup = document.getElementById(popupId);
      if (!popup) return;

      const closePopup = () => {
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      };

      const openPopup = (e) => {
        e?.preventDefault();
        popup.classList.add("is-open");
        popup.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      };
      trigger.addEventListener("click", openPopup);
      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openPopup(e);
        }
      });

      popup.querySelectorAll("[data-location-popup-close]").forEach((el) => {
        el.addEventListener("click", () => closePopup());
      });

      popup
        .querySelector(".product-location-popup-content")
        ?.addEventListener("click", (e) => {
          e.stopPropagation();
        });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      const openPopup = document.querySelector(
        ".product-location-popup.is-open"
      );
      if (openPopup) {
        openPopup.classList.remove("is-open");
        openPopup.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }
    });
  }

  function initAskShareModals() {
    const askTriggers = document.querySelectorAll(
      ".product-ask-question-trigger"
    );
    const shareTriggers = document.querySelectorAll(".product-share-trigger");

    function openModal(popupId) {
      const popup = document.getElementById(popupId);
      if (popup) {
        popup.classList.add("is-open");
        popup.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      }
    }

    function closeModal(popup) {
      if (popup) {
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }
    }

    askTriggers.forEach((btn) => {
      const popupId = btn.dataset.popupId;
      const popup = document.getElementById(popupId);
      if (!popup) return;

      btn.addEventListener("click", () => openModal(popupId));
      popup.querySelectorAll("[data-modal-close]").forEach((el) => {
        el.addEventListener("click", () => closeModal(popup));
      });
    });

    shareTriggers.forEach((btn) => {
      const popupId = btn.dataset.popupId;
      const popup = document.getElementById(popupId);
      if (!popup) return;

      btn.addEventListener("click", () => openModal(popupId));
      popup.querySelectorAll("[data-modal-close]").forEach((el) => {
        el.addEventListener("click", () => closeModal(popup));
      });

      const copyBtn = popup.querySelector("[data-copy-trigger]");
      const copyIcon = popup.querySelector("[data-copy-icon]");
      const copiedMsg = popup.querySelector("[data-copied-msg]");
      const urlInput = popup.querySelector(".product-share-url-input");
      if (copyBtn && urlInput) {
        copyBtn.addEventListener("click", () => {
          urlInput.select();
          urlInput.setSelectionRange(0, 99999);
          try {
            navigator.clipboard.writeText(urlInput.value);
            copyBtn.setAttribute("aria-label", "Copied!");
            copyBtn.classList.add("is-copied");
            if (copyIcon) copyIcon.setAttribute("aria-hidden", "true");
            if (copiedMsg) copiedMsg.setAttribute("aria-hidden", "false");
            setTimeout(() => {
              copyBtn.classList.remove("is-copied");
              copyBtn.setAttribute("aria-label", "Copy link");
              if (copyIcon) copyIcon.setAttribute("aria-hidden", "false");
              if (copiedMsg) copiedMsg.setAttribute("aria-hidden", "true");
            }, 2000);
          } catch (err) {
            document.execCommand("copy");
          }
        });
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const openModalEl = document.querySelector(
          ".product-modal-popup.is-open"
        );
        if (openModalEl) closeModal(openModalEl);
      }
    });
  }

  // Stock Warning
  function initStockWarning() {
    // Listen for cart updates to refresh warning
    if (
      typeof subscribe !== "undefined" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // Get current variant and update warning
        const variantSelect = productForm?.querySelector('select[name="id"]');
        if (variantSelect && variantData) {
          const currentVariantId = parseInt(variantSelect.value);
          const currentVariant = variantData.variants.find(
            (v) => v.id === currentVariantId
          );
          if (currentVariant) {
            updateStockWarning(currentVariant);
          }
        }
      });
    }
  }

  function updateStockWarning(variant) {
    // Try multiple selectors to find the element
    const stockWarning =
      productPage.querySelector("#product-stock-warning") ||
      document.querySelector("#product-stock-warning");
    const stockWarningMax =
      productPage.querySelector(".stock-warning-max") ||
      document.querySelector(".stock-warning-max");
    const quantityInput = productPage.querySelector(".quantity-input");

    if (!stockWarning || !stockWarningMax || !variant) {
      return;
    }

    // Get cart quantity for this variant
    let cartQuantity = 0;
    if (quantityInput) {
      const cartQtyAttr = quantityInput.getAttribute("data-cart-quantity");
      cartQuantity = parseInt(cartQtyAttr) || 0;
    }

    // Check if variant has max quantity rule
    const maxQuantity = variant.quantity_rule?.max;

    // Show warning if maxQuantity is a valid number greater than 0
    if (typeof maxQuantity === "number" && maxQuantity > 0) {
      stockWarningMax.textContent = maxQuantity;
      stockWarning.style.setProperty("display", "block", "important");
    } else {
      stockWarning.style.setProperty("display", "none", "important");
    }
  }

  // Check URL for variant parameter
  function checkUrlVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (variantId && variantData) {
      const variant = variantData.variants.find(
        (v) => v.id === parseInt(variantId)
      );
      if (variant) {
        // Select the variant
        const variantSelect = productForm?.querySelector('select[name="id"]');
        if (variantSelect) {
          variantSelect.value = variantId;
          variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  }

  // Sticky Bar Initialization
  function initStickyBar() {
    const stickyBar = document.getElementById("product-sticky-bar");
    const productForm = document.getElementById(productFormId);

    if (!stickyBar || !productForm) return;

    // Sync sticky bar with main form
    function syncStickyBar() {
      const mainQuantity = productForm.querySelector(".quantity-input");
      const stickyQuantity = stickyBar.querySelector(".quantity-input");
      const mainVariantId = productForm.querySelector(".product-variant-id");
      const stickyVariantId = stickyBar.querySelector(".product-variant-id");
      const mainAddBtn = productForm.querySelector(".add-to-cart-btn");
      const stickyAddBtn = stickyBar.querySelector(".add-to-cart-btn");

      if (mainQuantity && stickyQuantity) {
        stickyQuantity.value = mainQuantity.value;
        stickyQuantity.setAttribute(
          "data-min",
          mainQuantity.getAttribute("data-min") || "1"
        );
        stickyQuantity.setAttribute(
          "data-max",
          mainQuantity.getAttribute("data-max") || ""
        );
        stickyQuantity.setAttribute(
          "min",
          mainQuantity.getAttribute("min") || "1"
        );
        stickyQuantity.setAttribute(
          "max",
          mainQuantity.getAttribute("max") || ""
        );
        stickyQuantity.setAttribute(
          "step",
          mainQuantity.getAttribute("step") || "1"
        );
      }

      if (mainVariantId && stickyVariantId) {
        stickyVariantId.value = mainVariantId.value;
      }

      if (mainAddBtn && stickyAddBtn) {
        stickyAddBtn.disabled = mainAddBtn.disabled;
        // On mobile, preserve the button structure with price
        const isMobile = window.innerWidth <= 768;
        if (!isMobile) {
          stickyAddBtn.innerHTML = mainAddBtn.innerHTML;
        } else {
          // On mobile, only update disabled state, keep the price structure
          // The price will be updated by updateStickyBarVariant
        }
      }
    }

    // Update sticky bar prices and image
    function updateStickyBarVariant(variant) {
      if (!variant || !stickyBar) return;

      const currentPrice = stickyBar.querySelector(".product-current-price");
      const comparePrice = stickyBar.querySelector(".product-compare-price");
      const savings = stickyBar.querySelector(
        ".product-savings .save-discount"
      );
      const savingsContainer = stickyBar.querySelector(".product-savings");
      const image = stickyBar.querySelector(".product-sticky-bar__image img");
      const buttonPrice = stickyBar.querySelector(
        ".product-sticky-bar__button-price"
      );

      if (currentPrice) {
        currentPrice.textContent = Shopify.formatMoney(
          variant.price,
          window.money_without_trailing_zeros_format || window.money_format
        );
      }

      // Update button price on mobile
      if (buttonPrice) {
        buttonPrice.textContent = Shopify.formatMoney(
          variant.price,
          window.money_without_trailing_zeros_format || window.money_format
        );
      }

      if (variant.compare_at_price > variant.price) {
        if (comparePrice) {
          comparePrice.textContent = Shopify.formatMoney(
            variant.compare_at_price,
            window.money_without_trailing_zeros_format || window.money_format
          );
          comparePrice.style.display = "inline-flex";
        }
        if (currentPrice) {
          currentPrice.classList.add("red");
        }
        if (savings) {
          const saveValue = Math.ceil(
            100 - (variant.price / variant.compare_at_price) * 100
          );
          savings.textContent = `${window.saveText} ${saveValue}%`;
        }
        if (savingsContainer) {
          savingsContainer.style.display = "inline-flex";
        }
      } else {
        if (comparePrice) {
          comparePrice.style.display = "none";
        }
        if (currentPrice) {
          currentPrice.classList.remove("red");
        }
        if (savingsContainer) {
          savingsContainer.style.display = "none";
        }
      }

      // Update image if variant has featured image
      if (variant.featured_image && image) {
        const newImageSrc =
          variant.featured_image.src.split("?")[0] + "?width=100";
        image.src = newImageSrc;
        image.alt = variant.featured_image.alt || "";
      } else if (variant.featured_media && image) {
        const newImageSrc =
          variant.featured_media.src.split("?")[0] + "?width=100";
        image.src = newImageSrc;
        image.alt = variant.featured_media.alt || "";
      }

      syncStickyBar();
    }

    // Expose function globally for updateVariant to call
    window.updateStickyBarVariant = updateStickyBarVariant;
    function resetWhatsAppBottom() {
      const whatsappWidget = document.querySelector(".whatsapp-widget");
      if (whatsappWidget) {
        // Use setProperty with important flag to override inline styles
        whatsappWidget.style.setProperty("bottom", "10px", "important");
      }
    }
    function setWhatsAppBottom() {
      const whatsappWidget = document.querySelector(".whatsapp-widget");
      if (whatsappWidget) {
        // Use setProperty with important flag to override inline styles
        whatsappWidget.style.setProperty("bottom", "100px", "important");
      }
    }
    // IntersectionObserver to show/hide sticky bar
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            // Form is out of view, show sticky bar
            stickyBar.classList.add("active");
            setWhatsAppBottom();
          } else {
            // Form is in view, hide sticky bar
            stickyBar.classList.remove("active");
            resetWhatsAppBottom();
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    observer.observe(productForm);

    // Initialize sticky bar quantity selector
    const stickyMinusBtn = stickyBar.querySelector(".quantity-btn.minus");
    const stickyPlusBtn = stickyBar.querySelector(".quantity-btn.plus");
    const stickyQuantityInput = stickyBar.querySelector(".quantity-input");

    if (stickyQuantityInput) {
      const min = parseInt(
        stickyQuantityInput.dataset.min ||
          stickyQuantityInput.getAttribute("min") ||
          "1"
      );
      const max = parseInt(
        stickyQuantityInput.dataset.max ||
          stickyQuantityInput.getAttribute("max") ||
          "999"
      );

      if (stickyMinusBtn) {
        stickyMinusBtn.addEventListener("click", () => {
          const currentValue = parseInt(stickyQuantityInput.value || min);
          const newValue = Math.max(min, currentValue - 1);
          stickyQuantityInput.value = newValue;
          stickyQuantityInput.dispatchEvent(
            new Event("change", { bubbles: true })
          );

          // Sync to main form
          const mainQuantity = productForm.querySelector(".quantity-input");
          if (mainQuantity) {
            mainQuantity.value = newValue;
            mainQuantity.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      if (stickyPlusBtn) {
        stickyPlusBtn.addEventListener("click", () => {
          const currentValue = parseInt(stickyQuantityInput.value || min);
          const newValue = Math.min(max, currentValue + 1);
          stickyQuantityInput.value = newValue;
          stickyQuantityInput.dispatchEvent(
            new Event("change", { bubbles: true })
          );

          // Sync to main form
          const mainQuantity = productForm.querySelector(".quantity-input");
          if (mainQuantity) {
            mainQuantity.value = newValue;
            mainQuantity.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      // Handle direct input changes
      stickyQuantityInput.addEventListener("change", function () {
        const value = parseInt(this.value || min);
        let finalValue = value;
        if (isNaN(value) || value < min) {
          finalValue = min;
        } else if (value > max) {
          finalValue = max;
        }
        if (finalValue !== value) {
          this.value = finalValue;
        }

        // Sync to main form
        const mainQuantity = productForm.querySelector(".quantity-input");
        if (mainQuantity) {
          mainQuantity.value = finalValue;
          mainQuantity.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    // Sync sticky form submission with main form
    const stickyForm = stickyBar.querySelector(".product-sticky-bar__form");
    const stickyAddBtn = stickyBar.querySelector(".add-to-cart-btn");

    if (stickyForm) {
      stickyForm.addEventListener("submit", (e) => {
        e.preventDefault();

        // Show loading dots on sticky bar button
        if (stickyAddBtn) {
          let loadingDots = stickyAddBtn.querySelector(
            ".product-sticky-bar-loading-dots"
          );

          if (!loadingDots) {
            // Create loading dots HTML as overlay
            loadingDots = document.createElement("div");
            loadingDots.className = "product-sticky-bar-loading-dots";
            loadingDots.innerHTML = `
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            `;
            stickyAddBtn.appendChild(loadingDots);
          }

          // Show loading dots with opacity 1
          loadingDots.style.opacity = "1";
          stickyAddBtn.disabled = true;
        }

        // Sync quantity from sticky bar to main form before submission
        const stickyQuantity = stickyBar.querySelector(".quantity-input");
        const mainQuantity = productForm.querySelector(".quantity-input");
        if (stickyQuantity && mainQuantity) {
          mainQuantity.value = stickyQuantity.value;
        }

        // On mobile, use quantity 1
        const isMobile = window.innerWidth <= 768;
        if (isMobile && mainQuantity) {
          mainQuantity.value = "1";
        }

        // Trigger main form submission
        productForm.dispatchEvent(
          new Event("submit", { bubbles: true, cancelable: true })
        );
      });
    }

    // Listen for cart update to hide loading dots
    if (
      typeof PUB_SUB_EVENTS !== "undefined" &&
      typeof subscribe !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (stickyAddBtn) {
          const loadingDots = stickyAddBtn.querySelector(
            ".product-sticky-bar-loading-dots"
          );
          if (loadingDots) {
            // Fade out loading dots
            loadingDots.style.opacity = "0";
            loadingDots.style.transition = "opacity 0.3s ease";

            // Remove after fade out completes
            setTimeout(() => {
              if (loadingDots.parentNode) {
                loadingDots.remove();
              }
            }, 300);
          }
          stickyAddBtn.disabled = false;
        }
      });

      subscribe(PUB_SUB_EVENTS.cartError, () => {
        if (stickyAddBtn) {
          const loadingDots = stickyAddBtn.querySelector(
            ".product-sticky-bar-loading-dots"
          );
          if (loadingDots) {
            // Fade out loading dots
            loadingDots.style.opacity = "0";
            loadingDots.style.transition = "opacity 0.3s ease";

            // Remove after fade out completes
            setTimeout(() => {
              if (loadingDots.parentNode) {
                loadingDots.remove();
              }
            }, 300);
          }
          stickyAddBtn.disabled = false;
        }
      });
    }

    // Listen for variant changes
    const variantSelect = productForm.querySelector(".product-form__variants");
    if (variantSelect) {
      variantSelect.addEventListener("change", () => {
        const variantId = parseInt(variantSelect.value);
        const variant = variantData.variants.find((v) => v.id === variantId);
        if (variant) {
          updateStickyBarVariant(variant);
        }
        syncStickyBar();
      });
    }

    // Initial sync
    syncStickyBar();
    const currentVariantId = parseInt(
      productForm.querySelector(".product-variant-id")?.value || "0"
    );
    const currentVariant = variantData.variants.find(
      (v) => v.id === currentVariantId
    );
    if (currentVariant) {
      updateStickyBarVariant(currentVariant);
    }
  }
})();
